export const lzKebabToWordCase = (str) => {
    return (str + "")
        .toLowerCase()
        .split('-')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
};

export const lzSingularize = (str) => {
    const len = str.length;
    const last2 = str.substr(len - 2);
    const last3 = str.substr(len - 3);

    if ('ies' === last3) {
        return str.substr(0, len - 3) + 'y';
    }

    if (last3 !== 'les') {
        if ('es' === last2) {
            return str.substr(0, len - 2);
        }
    }

    if ('s' === str.substr(len - 1)) {
        return str.substr(0, len - 1);
    }

    return str;
};

export const lzPluralize = (str) => {
    const len = str.length;

    if ('y' === str.substr(len - 1)) {
        return str.substr(0, len - 1) + 'ies';
    }

    return str + 's';
};

export const lzInitials = (str) => {
    const parts = str.split(' ', 2);
    let ret = '';
    for (const part of parts) {
        ret += part.substring(0, 1);
    }
    return ret;
};
